
























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter, Action, State } from "vuex-class";
import AgentReadySwitch from "@/components/AgentReadySwitch.vue";
import CallControlBar from "@/components/Call/CallControlBar.vue";
import UserSideMenu from "@/components/UserSideMenu.vue";
import InComingCallDialog from "@/components/Call/InComingCallDialog.vue";
import WrapupTaskDialog from "@/components/WrapupTaskDialog.vue";
import BugReport from "@/components/BugReport.vue";
import PendingVerificationModal from "@/components/PendingVerifcationModal.vue";
import { createSideBar, getSessionId } from "@/configs";
import { CallMode, User, SideBarItems } from "@/types";
import logger from "@/configs/logger";
import createInactivityTimer, { InactivityTimer } from "inactivity-timer";
import { Routes } from "@/router/routes";
import { Route } from "vue-router";
import { collections } from "@/configs/firebase";
import "./styles/vuetify-overrides.scss";

@Component({
  components: {
    AgentReadySwitch,
    CallControlBar,
    UserSideMenu,
    WrapupTaskDialog,
    InComingCallDialog,
    PendingVerificationModal,
    BugReport
  }
})
export default class AppLayout extends Vue {
  @Getter("callMode") callMode!: CallMode;
  @Action("cleanupSession") cleanupSession!: Function;
  @State("config") config!: any;
  @State("user") user!: User;
  @State("access") userAccess!: any;

  sideNavigationItems!: SideBarItems;
  drawer = null;
  selected = 0;
  inactivityTimer!: InactivityTimer;

  @Watch("user")
  onUserUpdate(val: any, prev: any): void {
    if (val.sessionId && val.sessionId !== prev.sessionId) {
      if (val.sessionId !== getSessionId()) {
        logger("log", "new tab opened, session id:", val.sessionId);
        this.exitCurrentSession("new tab opened");
      }
    }
  }

  @Watch("$route")
  onUrlChange(val: Route, prev: Route): void {
    if (this.sideNavigationItems.find(item => item.routeName === val.name)) {
      if (val) this.setActiveRoute();
    }
  }

  get pageTitle() {
    return this.$route.name || "";
  }

  created(): void {
    this.sideNavigationItems = createSideBar(this.user.roles, this.userAccess);
    this.setActiveRoute();
    this.inactivityTimer = createInactivityTimer("2h", () =>
      this.exitCurrentSession("inactivity")
    );
    document.addEventListener("mousemove", this.inactivityTimer.signal);
  }

  beforeDestroy(): void {
    window.removeEventListener("mousemove", this.inactivityTimer.signal);
  }

  exitCurrentSession(reason: string): void {
    logger("warn", "exit current session due to", reason);
    this.$router.replace({ name: Routes.SessionExpired }).then(() => {
      this.cleanupSession();
    });
  }

  setActiveRoute(): void {
    if (!Array.isArray(this.sideNavigationItems)) return;
    this.selected = this.sideNavigationItems.findIndex(
      item => item.routeName === this.$route.name
    );
  }
}
